module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"privacy-policy":"Datenschutzerklärung"},"fr":{"privacy-policy":"Déclaration de protection des données"},"it":{"privacy-policy":"Informativa sulla protezione dei dati"}}')
  delete Component.options._Ctor
}
